import React from "react";
import Cookies from "js-cookie";
import Accordion from "../Accordion/Accordion";
import Address from "../Address/Address";
import AddressForm from "../AddressForm/AddressForm";
import * as GlobalStyle from "../../CSSStyles";

const ConfirmDelivery = (props) => {
  return (
    <Accordion
      tabName=""
      changed={props.changed}
      toggle={props.data.isDeliveryOpen}
      accordionId="accordionDelivery"
      classes="delivery-tab"
      profileEmail={props.profileEmail}
      data={props.data}
      customerIsGuest={props.customerIsGuest}
      chosenDeliveryAddressID={props.data.chosenDeliveryAddress.id}
      chosenDeliveryAddressFirstName={
        props.data.chosenDeliveryAddress.firstName
      }
      chosenDeliveryAddressLastName={props.data.chosenDeliveryAddress.lastName}
      chosenDeliveryAddressLine1={props.data.chosenDeliveryAddress.addressLine1}
      chosenDeliveryAddressLine2={props.data.chosenDeliveryAddress.addressLine2}
      chosenDeliveryAddressCity={props.data.chosenDeliveryAddress.city}
      chosenDeliveryAddressState={props.data.chosenDeliveryAddress.stateName}
      chosenDeliveryAddressPostCode={props.data.chosenDeliveryAddress.postCode}
      chosenDeliveryAddressCountryCode={
        props.data.chosenDeliveryAddress.countryCode
      }
      chosenDeliveryAddressCountryName={
        props.data.chosenDeliveryAddress.countryName
      }
      chosenDeliveryAddressPhoneNumber={
        props.data.chosenDeliveryAddress.phoneNumber
      }
    >
     {props.data.confirmApiLoader || props.data.bagLoader ? '':
      <div>
      {props.data.chosenDeliveryAddress.id ? (
        <p className="title">Please select an address</p>
      ) : (
        <p className="title">
          {/* No address saved yet */}

          {Cookies.get("kkUserEmail") ||
          props.isUserRegistered ||
          props.isGuestRegisterSuccess ? (
            "No address saved yet"
          ) : (
            <span
              style={{
                fontWeight: "400",
                fontSize: "1.6rem",
                display: "inline-block",
              }}
            >
              Please add your email address first
            </span>
          )}
        </p>
      )}

    {props.data.confirmAddressSummary &&
      props.data.confirmAddressSummary.length
        ? props.data.confirmAddressSummary.map((item, index) => (
            <Address
              key={item.id}
              id={item.id}
              firstName={item.firstName}
              lastName={item.lastName}
              addressLine1={item.streetAddress}
              addressLine2={item.streetAddress1}
              city={item.city}
              postCode={item.postcode}
              state={item.state}
              country={item.countryName}
              phoneNumber={item.telephoneNumber}
              addressType="delivery"
              isPrimary={item.isPrimary}
              selectedAddress={item.selectedShippingAddress}
              updateSelectedAddress={(event) =>
                props.chosenCountryCode != item.countryId
                  ? props.changeCountryPrompt(
                      event,
                      item.id,
                      item.countryId,
                    )
                  : props.updateSelectedDeliveryAddress(
                      event,
                      item.id,
                      item.countryId,
                    )
              }
              defaultDeliveryAddressID={props.defaultDeliveryAddressID}
              isDeleteAddressModalOpen={(event) =>
                props.isDeleteAddressModalOpenHandler(item.id)
              }
              editAddressToggle={() =>
                props.showEditAddressHandler(
                  item.id,
                  item.customerId,
                  item.countryId,
                  item.countryName,
                  item.firstName,
                  item.lastName,
                  item.streetAddress,
                  item.streetAddress1,
                  item.city,
                  0,
                  item.state,
                  item.state,
                  item.postcode,
                  item.telephoneNumber,
                  item.emailAddr,
                  "delivery"
                )
              }
              showDeliveryEditAddressFormID={
                props.data.showDeliveryEditAddressFormID
              }
              showBillingEditAddressFormID={
                props.data.showBillingEditAddressFormID
              }
              handleKeyDown={(e) => props.handleKeyDown(e, item.id, "delivery")}
            >
              {props.data.showEditAddressForm ? (
                <AddressForm
                  title="Edit address"
                  process="edit"
                  stateKeyDown={props.stateKeyDown}
                  addressLine2={item.streetAddress1}
                  close={(event) => props.closeAddressModalHandler(event)}
                  data={props.data}
                  myRef={props.addressFirstNameRef}
                  onCountryFocus={(event) => props.countryFocusHandler(event)}
                  onCountryBlur={(event) => props.countryBlurHandler(event)}
                  onCountryChange={(event) =>
                    props.addModalChangedHandler(event, "addressRegion")
                  }
                  countryOptions={props.countryOptionsHandler}
                  countryComponents={props.countryComponents}
                  onCountryInputChange={props.countryInputHandler}
                  onFirstNameChange={(event) =>
                    props.addModalChangedHandler(event, "addressFirstName")
                  }
                  onLastNameChange={(event) =>
                    props.addModalChangedHandler(event, "addressLastName")
                  }
                  onLine1Change={(event) =>
                    props.addModalChangedHandler(event, "addressLine1")
                  }
                  onLine2Change={(event) =>
                    props.addModalChangedHandler(event, "addressLine2")
                  }
                  onNewAddressLineClick={(event) =>
                    props.addAddressLineModalHandler(event)
                  }
                  onCityChange={(event) =>
                    props.addModalChangedHandler(event, "addressCity")
                  }
                  stateZoneList={props.data.stateZone}
                  onStateZoneFocus={(event) =>
                    props.stateZoneFocusHandler(event)
                  }
                  onStateZoneBlur={(event) => props.stateZoneBlurHandler(event)}
                  onStateZoneChange={(event) =>
                    props.addModalChangedHandler(event, "addressStateZone")
                  }
                  onStateChange={(event) =>
                    props.addModalChangedHandler(event, "addressState")
                  }
                  onPostalChange={(event) =>
                    props.addModalChangedHandler(event, "addressPostal")
                  }
                  onPhoneChange={(event) =>
                    props.addModalChangedHandler(event, "addressPhone")
                  }
                  onSaveClick={
                    props.data.saveAddressActive
                      ? (e) =>
                          props.addAddressModalHandler('delivery')
                      : null
                  }
                  onMakeAsDefaultChange={props.onMakeAsDefaultChange}
                  isPrimary={item.isPrimary}
                />
              ) : null}
            </Address>
          ))
        : ""}
      {props.data.showAddDelAddressForm ? '':
        <GlobalStyle.AddAddressStyle
          title="Add an address"
          className={
            Cookies.get("kkUserEmail") ||
            props.isUserRegistered ||
            props.isGuestRegisterSuccess
              ? "enabled"
              : "disabled"
          }
          onClick={
            props.isUserRegistered || props.isGuestRegisterSuccess
              ? (event) => props.showAddressModalHandler("addDeliveryAddress")
              : null
          }
        >
          <p>+ Add Address</p>
        </GlobalStyle.AddAddressStyle>
      }

      {props.data.showAddDelAddressForm ? (
        <AddressForm
          title="Add address"
          process="add"
          isUserRegistered={props.isUserRegistered}
          stateKeyDown={props.stateKeyDown}
          close={(event) => props.closeAddressModalHandler(event)}
          data={props.data}
          myRef={props.addressFirstNameRef}
          onCountryFocus={(event) => props.countryFocusHandler(event)}
          onCountryBlur={(event) => props.countryBlurHandler(event)}
          onCountryChange={(event) =>
            props.addModalChangedHandler(event, "addressRegion")
          }
          countryOptions={props.countryOptionsHandler}
          countryComponents={props.countryComponents}
          onCountryInputChange={props.countryInputHandler}
          onFirstNameChange={(event) =>
            props.addModalChangedHandler(event, "addressFirstName")
          }
          onLastNameChange={(event) =>
            props.addModalChangedHandler(event, "addressLastName")
          }
          onLine1Change={(event) =>
            props.addModalChangedHandler(event, "addressLine1")
          }
          onLine2Change={(event) =>
            props.addModalChangedHandler(event, "addressLine2")
          }
          onNewAddressLineClick={(event) =>
            props.addAddressLineModalHandler(event)
          }
          onCityChange={(event) =>
            props.addModalChangedHandler(event, "addressCity")
          }
          stateZoneList={props.data.stateZone}
          onStateZoneFocus={(event) => props.stateZoneFocusHandler(event)}
          onStateZoneBlur={(event) => props.stateZoneBlurHandler(event)}
          onStateZoneChange={(event) =>
            props.addModalChangedHandler(event, "addressStateZone")
          }
          onStateChange={(event) =>
            props.addModalChangedHandler(event, "addressState")
          }
          onPostalChange={(event) =>
            props.addModalChangedHandler(event, "addressPostal")
          }
          onPhoneChange={(event) =>
            props.addModalChangedHandler(event, "addressPhone")
          }
          onSaveClick={
            props.data.saveAddressActive
              ? (e) => props.addAddressModalHandler('delivery')
              : null
          }
          onMakeAsDefaultChange={props.onMakeAsDefaultChange}
        />
      ) : null}
      </div>
    }
    </Accordion>
  );
};

export default ConfirmDelivery;
